import { ETC_OUTBOUND_MAX_SAVE_SIZE } from '@/services/outbound/outboundEtc/consts'

/** GI38 기타출고 화면 상수. 데이터 계약 상수는 services/outbound/outboundEtc/consts.ts 에 있다. */

/** 다운로드 사유 상세 최소 길이 — 1.0 공용 사유 팝업과 같다. */
export const REASON_DETAIL_MIN_LENGTH = 5

/** 엑셀 감사로그 MENU_CD — 2.0 화면코드(1.0 GI35). */
export const EXPORT_LOG_MENU_CD = 'GI38'

export const MESSAGES = {
  shipperRequired: '화주명은 필수입니다.',
  shipperLoadFailed: '화주 목록을 가져올 수 없습니다. 다시 시도해 주세요.',
  searchFailed: '조회 중 오류가 발생했습니다.',
  /** BE 0건 응답(`EtcOutboundOrderResponse.empty`)의 문구 — 서비스가 0건을 빈 결과로 바꿔 화면이 띄운다. */
  searchEmpty: '조회된 결과가 존재하지 않습니다.',
  saveFailed: '저장 중 오류가 발생했습니다.',
  confirmFailed: '확정 중 오류가 발생했습니다.',
  noSelectedRows: '선택된 데이터가 없습니다.',
  noEditedRows: '저장할 변경 내용이 없습니다.',
  phoneInvalid: '전화번호, 핸드폰 번호에 숫자와 -, + 이외의 값은 입력할 수 없습니다.',
  zipCodeInvalid: '우편번호에 숫자와 - 이외의 값은 입력할 수 없습니다.',
  transportTypeMissing: ({ orderNumber }: { orderNumber: string }) =>
    `주문번호 ${orderNumber}의 배송유형이 비어 있어 확정할 수 없습니다. 배송유형을 선택해주세요.`,
  transportTypeInvalid: ({ orderNumber, value }: { orderNumber: string; value: string }) =>
    `주문번호 ${orderNumber}의 배송유형(${value})은 확정할 수 없는 값입니다. 배송유형을 다시 선택해주세요.`,
  confirmUnsavedRow: ({ orderNumber }: { orderNumber: string }) =>
    `주문번호 ${orderNumber}에 저장하지 않은 변경 사항이 있어 확정할 수 없습니다. 저장한 뒤 다시 확정해주세요.`,
  requiredMissing: ({ rowNumber, title, particle }: { rowNumber: number; title: string; particle: string }) =>
    `${rowNumber}번째 행의 ${title}${particle} 비어 있습니다.`,
  excelNoRows: '다운로드 할 데이터가 없습니다. 조회 후 다운로드 해주세요.',
  saveSizeExceeded: '1회 저장시 최대 5,000개까지 가능합니다.',
  confirmSizeExceeded: '최대 5,000개까지 확정 가능합니다. 주문 개수를 확인해주세요.',
  duplicateReasonRequired: '사유 입력은 필수입니다.',
  progressFailed: '일시적인 오류로 처리에 실패했어요.\n잠시 후 다시 시도해주세요.',
  confirmSend: '데이터 송신을 시작 하시겠습니까?',
  // 컨덕터 뷰의 엑셀 사유 모달은 [확인] 을 잠그지 않는다(업로드 모달만 파일 전 [업로드] 잠금) — 배선이 막고 모달을 유지한다(throw).
  downloadReasonInvalid: `사유코드를 고르고 상세사유를 ${REASON_DETAIL_MIN_LENGTH}글자 이상 입력해주세요.`,
  uploadFileRequired: '업로드할 엑셀 파일을 선택해주세요.',
  uploadXlsxOnly: '엑셀(.xlsx) 파일만 업로드할 수 있습니다.',
  uploadNoRows: '업로드할 데이터가 없습니다.',
  uploadReadFailed: '엑셀을 읽지 못했습니다.',
  // 저장 상한을 넘는 파일은 어차피 저장되지 않는다 — 표에 올리기 전에 막아 대량 렌더로 탭이 멈추지 않게 한다(LOGISPRD-14800).
  // 표 선택은 뷰 소유라 업로드 뒤 전량 선택(1.0 selectAll)을 못 한다 — 사용자가 직접 고르도록 안내한다(컨덕터 슬롯이 생기면 문구 되돌림).
  uploadDone: (count: number) => `${count}건을 표에 올렸습니다. 확인 후 전체 선택하고 저장해주세요.`,
  saveDone: '저장되었습니다.',
  confirmDone: '기타 출고 확정이 완료되었습니다.',
  saveFailedTitle: '저장 실패',
  confirmFailedTitle: '확정 실패',
  confirmCancelled: '확정을 취소했습니다.',
  // 문구는 일반입고 2.0 [삭제](컨덕터 inboundDeleteConfirm)와 같다.
  deleteConfirm: (count: number) => `선택한 ${count}건을 삭제하시겠습니까?`,
  deleteDone: (count: number) => `${count}건 삭제 완료`,
  deleteCancelled: '삭제를 취소했습니다.',
  deleteSizeExceeded: `1회 삭제시 최대 ${ETC_OUTBOUND_MAX_SAVE_SIZE.toLocaleString()}개까지 가능합니다.`,
  requestFailed: '요청에 실패했습니다.',
  // 옛 필터는 화주유형을 바꾸면 후보 밖 화주코드를 폼에서 지웠다 — 조회영역이 뷰 소유라 못 지우므로 조회 때 막는다(그대로 나가면 BE 가 조용히 0건).
  shipperTypeMismatch: '고른 화주유형에 속하지 않는 화주명입니다. 화주명을 다시 골라주세요.',
  // 페이지 이동 = 서버 재조회 — 저장하지 않은 편집·업로드 행은 사라진다.
  leaveUnsaved: '저장하지 않은 변경 내용이 있습니다. 페이지를 옮기면 사라집니다. 계속할까요?',
  resetUnsaved: '저장하지 않은 변경 내용이 있습니다. 초기화하면 사라집니다. 계속할까요?',
} as const
